import Tracker from './Tracker';

const accountTracker = new Tracker(null, {
	CREATE: 'Created account',
	UPDATE: 'Updated account'
});

export default accountTracker;
